import React from 'react'
import {
  Button,
  Card,
  Grid,
  Icon
} from 'semantic-ui-react'
import forms from './../../../config/forms'


const ManageForm = ({ save, close, args }) => {

  const { defaultForm, login, passwordRecovery, signUp, bookAppointment } = forms || {}

  const onHandleCompleted = (event, choice) => {
    let form = {}
    switch (choice) {
      case 'login':
        form = login
        break
      case 'passwordRecovery':
        form = passwordRecovery
        break
      case 'signUp':
        form = signUp
        break
      case 'bookAppointment':
        form = bookAppointment
        break
      default:
        form = defaultForm
    }
    save({ ...form })
  }

  const onHandleClose = () => {
    close()
  }

  const FormChoices = () => {
    return (
      <>
        <div style={{ width: '100%', marginBottom: '25px' }}>
          <div style={{ color: 'black', paddingBottom: '15px'}}>Choose the form you wish to include in your page:</div>
          <Grid columns="2">
            <Grid.Row>
              <Grid.Column>
                <Card fluid onClick={e => onHandleCompleted(e, 'login')}>
                  <Card.Content>
                    <Card.Header>Login</Card.Header>
                    <Card.Description>
                      A simple user/password form.
                    </Card.Description>
                  </Card.Content>
                </Card>
              </Grid.Column>
              <Grid.Column>
                <Card fluid onClick={e => onHandleCompleted(e, 'passwordRecovery')}>
                  <Card.Content>
                    <Card.Header>Password recovery</Card.Header>
                    <Card.Description>
                      To let a user retrieve/change the password.
                    </Card.Description>
                  </Card.Content>
                </Card>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <Card fluid onClick={e => onHandleCompleted(e, 'signUp')}>
                  <Card.Content>
                    <Card.Header>Signup</Card.Header>
                    <Card.Description>
                      A newsletter signup form.
                    </Card.Description>
                  </Card.Content>
                </Card>
              </Grid.Column>
              <Grid.Column>
                <Card fluid onClick={e => onHandleCompleted(e, 'bookAppointment')}>
                  <Card.Content>
                    <Card.Header>Book an appointment</Card.Header>
                    <Card.Description>
                      Collect basic data for event registration.
                    </Card.Description>
                  </Card.Content>
                </Card>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </ >
    )
  }

  const FormActions = () => {
    return (
      <>
        <div
          className="actions"
          style={{ width: '100%', textAlign: 'center', marginTop: '5px' }}>
          <Button onClick={onHandleClose}>
            <i className="chevron circle right icon"></i> Cancel
          </Button>
        </div>
      </ >
    )
  }

  return (
    <>
      <FormChoices />
      <FormActions />
    </>
  )
}

export default ManageForm
